import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3b15ceb1: FaireBrandEntity = {
  token: "b_3b15ceb1",
  type: "brand",
  name: "Love & Victory",
  avatarUrl:
    "https://cdn.faire.com/fastly/16ee16cd23e9ac4da235cdba2fcac964f61c4afb2185d29ecb6f486e9823936e.webp",
  bannerUrl:
    "https://cdn.faire.com/fastly/43ff608df459ebe066894a2b03308cfd9c369551bd38f9c749e7905f12ccfe9c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/16ee16cd23e9ac4da235cdba2fcac964f61c4afb2185d29ecb6f486e9823936e.webp",
  heroImageUrl:
    "https://cdn.faire.com/fastly/43ff608df459ebe066894a2b03308cfd9c369551bd38f9c749e7905f12ccfe9c.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 60,
  isTopShop: true,
  isInsider: true,
  description:
    "Love & Victory is a multidisciplinary creative studio founded in 2008 by designer Meg Moorhouse as a one-stop resource for thoughtfully-designed, quality goods that shine a spotlight on her favorite things: delicious food, stiff drinks, soulful tunes, and socially relevant causes. \n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:48.922Z",
    importedBy: "entity-db-cli",
  },
};
